import { END_POINTS } from "../constants/urls";
import { CommonBody } from "../types/General";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
  status: number;
  data?: any;
  message: string;
};

export const groupsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getTagGroups: builder.query<
      CommonResponse,
      { search: string; page: number }
    >({
      query: ({ search, page }) => ({
        url: `${END_POINTS.getTagGroups}?search=${search}&pageNo=${page}`,
        method: "GET",
      }),
    }),

    addTagGroups: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.addTagGroup,
        method: "POST",
        body,
      }),
    }),

    changeTagGroupStatus: builder.mutation<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.changeTagGroupStatus}?Id=${id}`,
        method: "POST",
      }),
    }),

    deleteTagGroup: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteTagGroup}?Id=${id}`,
        method: "DELETE",
      }),
    }),

    updateTagGroup: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: `${END_POINTS.updateTagGroup}`,
        method: "PATCH",
        body,
      }),
    }),

    getTags: builder.query<
      CommonResponse,
      { search: string; groupId: string | undefined; page: number }
    >({
      query: ({ search, groupId, page }) => ({
        url: `${END_POINTS.getTags}/${groupId}?search=${search}&pageNo=${page}`,
        method: "GET",
      }),
    }),

    addTags: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.createTags,
        method: "POST",
        body,
      }),
    }),

    updateTags: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: `${END_POINTS.updateTags}`,
        method: "PATCH",
        body,
      }),
    }),

    changeTagStatus: builder.mutation<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.changeTagStatus}?Id=${id}`,
        method: "POST",
      }),
    }),

    deleteTags: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteTags}?Id=${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetTagGroupsQuery,
  useAddTagGroupsMutation,
  useChangeTagGroupStatusMutation,
  useLazyDeleteTagGroupQuery,
  useUpdateTagGroupMutation,
  useLazyGetTagsQuery,
  useAddTagsMutation,
  useUpdateTagsMutation,
  useLazyDeleteTagsQuery,
  useChangeTagStatusMutation,
} = groupsApi;
